import { render, staticRenderFns } from "./PacientesDetalleConsultas.vue?vue&type=template&id=6cb40ab1&"
import script from "./PacientesDetalleConsultas.vue?vue&type=script&lang=js&"
export * from "./PacientesDetalleConsultas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports